/**
 *
 * @module entry
 * @desc {SDK.Media.AdEngine} entry point.
 *
 */

import AdEngineManager from './adEngineManager';
import AdvertisingIdProvider from './advertisingIdProvider';

/**
 *
 * @typedef SDK.Media.AdEngine
 * @type {Object}
 *
 * @property {AdEngineManager} AdEngineManager
 * @property {AdvertistingIdProvider} AdvertistingIdProvider
 *
 */

/**
 *
 * @type {SDK.Media.AdEngine}
 *
 */
export default {

    AdEngineManager,
    AdvertisingIdProvider

};



// WEBPACK FOOTER //
// ./src/media/adEngine/entry.js